var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('Home'),_c('Footer'),_c('Drawer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }